import { render } from "./transactiontabset.vue?vue&type=template&id=681d5db3"
import script from "./transactiontabset.vue?vue&type=script&lang=js"
export * from "./transactiontabset.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__